module.exports = __webpack_public_path__ + "static/media/chamadogarcon.bad3d183.svg";